export const DESIGN_ELEMENT_LAYER_DROPDOWN = {
  SEND_ELEMENT_BACKWARD_OPTION: {
    key: 'SEND_ELEMENT_TO_BACKWARD_OPTION',
    value: 'Send Backward',
  },
  SEND_ELEMENT_TO_BACK_OPTION: {
    key: 'SEND_ELEMENT_TO_BACK_OPTION',
    value: 'Send to Back',
  },
  BRING_ELEMENT_FORWARD_OPTION: {
    key: 'BRING_ELEMENT_FORWARD_OPTION',
    value: 'Bring Forward',
  },
  BRING_ELEMENT_TO_FRONT_OPTION: {
    key: 'BRING_ELEMENT_TO_FRONT_OPTION',
    value: 'Bring To Front',
  },
  SAVE_AS_REUSABLE_ASSET_OPTION: {
    key: 'SAVE_AS_REUSABLE_ASSET_OPTION',
    value: 'Save as Reusable Asset',
  },
  SAVE_AS_REFERENCED_ASSET_OPTION: {
    key: 'SAVE_AS_REFERENCED_ASSET_OPTION',
    value: 'Save as Referenced Asset',
  },
  AI_AUTO_FILL_CONTENT_WRITE_FOR_ME_OPTION: { key: 'AI_AUTO_FILL_CONTENT_WRITE_FOR_ME_OPTION', value: 'Write For Me' },

  MAP_A_VARIABLE: { key: 'MAP_A_VARIABLE', value: 'Map a variable' },

  STATIC_TABLE_MERGE : {
    key: 'STATIC_TABLE_MERGE', value: 'Merge' 
  },
  STATIC_TABLE_UNMERGE : {
    key: 'STATIC_TABLE_UNMERGE', value: 'Unmerge' 
  },
  STATIC_TABLE_DELETE_ROW : {
    key: 'STATIC_TABLE_DELETE_ROW', value: 'Delete Row' 
  },
  STATIC_TABLE_DELETE_COLUMN : {
    key: 'STATIC_TABLE_DELETE_COLUMN', value: 'Delete Column' 
  },
  STATIC_TABLE_DUPLICATE_ROW : {
    key: 'STATIC_TABLE_DUPLICATE_ROW', value: 'Duplicate Row'
  },
  STATIC_TABLE_DUPLICATE_COLUMN : {
    key: 'STATIC_TABLE_DUPLICATE_COLUMN', value: 'Duplicate Column'
  },
  STATIC_TABLE_COPY : {
    key: 'STATIC_TABLE_COPY', value: 'Copy'
  },
  STATIC_TABLE_PASTE : {
    key: 'STATIC_TABLE_PASTE', value: 'Paste'
  },
  STATIC_TABLE_DELETE : {
    key: 'STATIC_TABLE_DELETE', value: 'Delete Cell Content'
  },
  ADD_TO_TOC:{
    key: 'ADD_TO_TOC', value: 'Add to TOC'
  },
  DELETE_ALL_COLUMN_WARN:{
    key: 'DELETE_ALL_COLUMN_WARN', value: 'Cannot delete all columns of the table!!'
  },
  DELETE_ALL_ROW_WARN:{
    key: 'DELETE_ALL_ROW_WARN', value: 'Cannot delete all rows of the table!!'
  },
  RESIZE_COLUMN_WARN:{
    key: 'RESIZE_COLUMN_WARN', value: 'Cannot resize column to given dimension since it is too small!!'
  },
  GROUPING: {
    key: 'GROUPING',
    value: 'Group',
  },
  UN_GROUPING: {
    key: 'UN_GROUPING',
    value: 'UnGroup',
  },
  ADD_BUSINESS_LOGIC: {
    key: 'ADD_BUSINESS_LOGIC',
    value: 'Add Business Logic',
  },

};

export const GROUPING_MODAL = {
  GROUP_NAME: {
    key: 'GROUP_NAME',
    value: 'Enter the group name',
  },
  GROUP_NAME_PLACEHOLDER: {
    key: 'GROUP_NAME_PLACEHOLDER',
    value: 'Type here...',
  },
  GROUP_NAME_SAVE: {
    key: 'GROUP_NAME_SAVE',
    value: 'Save',
  },
}